// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0',
  revision: 'a2aa35e5d',
  branch: 'master',
  date: 'Thu, 22 Oct 2026 12:42:21 GMT'
};